import * as actionTypes from 'modules/appointments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const selectAppointment = (state, { payload }) => payload?.id ?? state;

const clearSelectedAppointment = () => initialState;

export default createReducer(initialState, {
  [actionTypes.POST_SUCCESS]: selectAppointment,
  [actionTypes.SET_SELECTED_ID]: selectAppointment,
  [actionTypes.FETCH_APPOINTMENT_REQUEST]: selectAppointment,
  [actionTypes.DELETE_SUCCESS]: clearSelectedAppointment,
});
